import React, { useState, useEffect, useContext } from "react";
import TopBar from "../../components/topbar";
import Header from "../../components/header";
import { Row, Col, Button, Container, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { GlobalContext } from "../../contexts/global";
import { MdEdit, MdDelete, MdShare } from "react-icons/md";
import { decode as base64_decode, encode as base64_encode } from 'base-64';
import { ModalMenuProposta, ModalInputSimples } from "../../components/modals";
import copy from "copy-to-clipboard";
import { AlertaMensagem } from "../../components/alerts";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { update } from "js-md5";



function TelaPropostas() {

    const { conexao, loading, setLoading, alerta, setAlerta, usuario } = useContext(GlobalContext)

    const Navigate = useNavigate()

    const [proposals, setProposals] = useState([]);

    const [modalMenu, setModalMenu] = useState(false);
    const [modalEmail, setModalEmail] = useState(false);

    const [propostaSelecionada, setPropostaSelecionada] = useState({});

    async function sendPropostaEmail(proposta, email) {
        axios.post(conexao.endereco + '/proposals/share/email',
            {
                "proposal": proposta,
                "email": email,
            }, { headers: { token: localStorage.getItem('Token') } })

            .then(function (response) {
                if (response.status == 200) {
                    toast.success('Proposta enviada com sucesso!')
                    updateStatusProposta('enviada')
                }
                else {
                    setAlerta({
                        show: true,
                        titulo: 'Falha ao Enviar a Proposta',
                        mensagem: 'Verifique o e-mail digitado, ou acione nosso suporte',
                        textoBotao: 'Ok'
                    })
                }
            })
            .catch(function (error) {
                setAlerta({
                    show: true,
                    titulo: 'Falha ao Enviar a Proposta',
                    mensagem: error,
                    textoBotao: 'Ok'
                })
            })

    }

    async function getPropostas() {
        axios.post(conexao.endereco + '/proposals/list',
            {
                "user": usuario.user_id ? usuario.user_id : localStorage.getItem('userID'),
            }, { headers: { token: localStorage.getItem('Token') } })

            .then(function (response) {
                setLoading(false)
                if (response.status == 200) {
                    setProposals(response.data)
                }
            })
            .catch(function (error) {
                console.error(error)
                setLoading(false)
            })
    }

    async function updateStatusProposta(status) {

        axios.post(conexao.endereco + '/proposals/edit/status',
            {
                "proposal": propostaSelecionada.prop_id,
                "status": status
            }, { headers: { token: localStorage.getItem('Token') } })

            .then(function (response) {
                setLoading(false)
                if (response.status == 200) {
                    toast.info('Status atualizado para ' + status)
                    getPropostas()
                }
            })
            .catch(function (error) {
                console.error(error)
                setLoading(false)
            })
    }

    async function duplicateProposta() {
        axios.post(conexao.endereco + '/proposals/create',
            {
                "user": usuario.user_id ? usuario.user_id : localStorage.getItem('userID'),
                "title": propostaSelecionada.prop_title + ' (Cópia)',
                "customer": propostaSelecionada.prop_customer_id,
                "description": propostaSelecionada.prop_description,
                "type": propostaSelecionada.prop_type,
                "items": propostaSelecionada.prop_items,
                "payment_conditions": propostaSelecionada.prop_payment_conditions,
                "total": propostaSelecionada.prop_total,
                "discount": propostaSelecionada.prop_discount,
                "final_value": propostaSelecionada.prop_final_value,
                "negociation": propostaSelecionada.prop_negociation,
                "validity": propostaSelecionada.prop_validity,
                "attachment": null,
            }, { headers: { token: localStorage.getItem('Token') } })

            .then(function (response) {
                setLoading(false)
                if (response.status == 201) {
                    getPropostas()
                    toast.success('Proposta duplicada com sucesso!')
                    toast.info('Anexo não é duplicado')
                }
            })
            .catch(function (error) {
                console.error(error)
                setLoading(false)
            })
    }

    useEffect(() => {
        getPropostas()
    }, [])

    return (
        <div>
            <TopBar ativo='propostas' />
            <Container>
                <Header titulo='Propostas'>
                    <Button style={{ backgroundColor: '#026eb6', border: 'none' }} size="sm" block onClick={() => { Navigate('/propostas/nova') }}>
                        Incluir
                    </Button>
                    <Button style={{ backgroundColor: '#026eb6', border: 'none', marginLeft: 15 }} size="sm" block type="buttom" onClick={() => {
                        getPropostas()
                    }}>
                        Atualizar
                    </Button>
                </Header>


                <Row style={{ marginTop: 15 }}>
                    <Col>
                        <div style={{ backgroundColor: 'gainsboro', width: '100%', height: 40, borderStartStartRadius: 10, borderStartEndRadius: 10, display: 'flex' }}>
                            <Col lg={6} style={{ display: 'flex', alignItems: 'center', height: 40, paddingLeft: 15 }}>
                                Título
                            </Col>
                            <Col lg={2} style={{ display: 'flex', alignItems: 'center', height: 40, justifyContent: 'flex-start' }}>
                                Cliente
                            </Col>
                            <Col lg={2} style={{ display: 'flex', alignItems: 'center', height: 40, justifyContent: 'center' }}>
                                Valor
                            </Col>
                            <Col lg={2} style={{ display: 'flex', alignItems: 'center', height: 40, justifyContent: 'center' }}>
                                Status
                            </Col>
                        </div>
                        {proposals.map((item, index) => (

                            <div
                                className="item-busca-proposta"
                                // onClick={() => { Navigate(`/propostas/edicao/${base64_encode(item.prop_id)}`) }}
                                onClick={() => {
                                    setPropostaSelecionada(item)
                                    setModalMenu(true)
                                }}
                            >
                                <Col lg={6} style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', height: 60, paddingLeft: 15, textTransform: 'capitalize', flexDirection: 'column' }}>
                                    <div>
                                        {item.prop_title}
                                    </div>
                                    <div>
                                        <sup>{item.prop_type}</sup>
                                    </div>
                                </Col>
                                <Col lg={2} style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', height: 60, flexDirection: 'column' }}>
                                    <div style={{ textTransform: 'capitalize' }}>
                                        {item.cust_name}
                                    </div>
                                    <div>
                                        <sup>{item.cust_email}</sup>
                                    </div>
                                </Col>
                                <Col lg={2} style={{ display: 'flex', alignItems: 'center', height: 60, justifyContent: 'center' }}>
                                    {item.prop_final_value ? Number(item.prop_final_value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 0}
                                </Col>
                                <Col lg={2} style={{ display: 'flex', alignItems: 'center', height: 60, justifyContent: 'center' }}>
                                    <Badge bg={
                                        item.prop_status == 'rascunho' ? 'info' :
                                            item.prop_status == 'enviada' ? 'primary' :
                                                item.prop_status == 'negociação' ? 'warning' :
                                                    item.prop_status == 'aprovada' ? 'success' : 'danger'
                                    }>
                                        {item.prop_status}
                                    </Badge>
                                </Col>
                                {/* <Col lg={1} style={{ display: 'flex', alignItems: 'center', height: 60, justifyContent: 'space-evenly', zIndex: 10 }}>
                                    <Hint posicao="top" id="send-proposal" texto="Enviar Proposta">
                                        <div onClick={() => {
                                            setModalCompartilhar(true)
                                        }} style={{ cursor: 'pointer' }}>
                                            <MdShare color="green" />
                                        </div>
                                    </Hint>
                                    <Hint posicao="top" id="delete-proposal" texto="Excluir Proposta">
                                        <div onClick={() => {
                                            // deleteCliente(item.cust_id)
                                        }} style={{ cursor: 'pointer' }}>
                                            <MdDelete color="red" />
                                        </div>
                                    </Hint>
                                </Col> */}
                            </div>

                        ))}
                        <div style={{ backgroundColor: 'gainsboro', width: '100%', height: 40, borderEndStartRadius: 10, borderEndEndRadius: 10, display: 'flex' }}>
                            <Col lg={5} style={{ display: 'flex', alignItems: 'center', height: 40, paddingLeft: 15 }}>
                                <sub>{proposals.length} Proposta(s) Cadastrada(s)</sub>
                            </Col>
                            <Col lg={2} style={{ display: 'flex', alignItems: 'center', height: 40, justifyContent: 'center' }}>

                            </Col>
                            <Col lg={2} style={{ display: 'flex', alignItems: 'center', height: 40, justifyContent: 'center' }}>

                            </Col>
                            <Col lg={2} style={{ display: 'flex', alignItems: 'center', height: 40, justifyContent: 'center' }}>

                            </Col>
                        </div>
                    </Col>
                </Row>
            </Container>
            <AlertaMensagem
                show={alerta.show}
                close={() => setAlerta({ ...alerta, show: false })}
                titulo={alerta.titulo}
                mensagem={alerta.mensagem}
                textoBotao={alerta.textoBotao}
            />
            <ModalMenuProposta
                show={modalMenu}
                setShow={setModalMenu}
                onHide={() => setModalMenu(false)}
                centered
                clickEditar={() => {
                    setModalMenu(false)
                    Navigate(`/propostas/edicao/${base64_encode(propostaSelecionada.prop_id)}`)
                }}
                clickDuplicar={() => {
                    setModalMenu(false)
                    duplicateProposta()
                }}
                clickNegociacao={() => {
                    setModalMenu(false)
                    Navigate(`/propostas/negociacao/${base64_encode(propostaSelecionada.prop_id)}`)
                }}
                clickEnviarEmail={() => {
                    if (Number(usuario.restante < 1 && usuario.user_plan == 0)) {
                        setAlerta({
                            show: true,
                            titulo: 'Opção Indisponível',
                            mensagem: 'O Envio de Propostas por e-mail está disponível apenas no plano PROFISSIONAL',
                            textoBotao: 'Ok'
                        })
                    } else {
                        setModalMenu(false)
                        setModalEmail(true)
                    }
                    // setModalMenu(false)

                }}
                clickEnviarWhatsApp={() => {
                    if (Number(usuario.restante < 1 && usuario.user_plan == 0)) {
                        setAlerta({
                            show: true,
                            titulo: 'Opção Indisponível',
                            mensagem: 'O Envio de Propostas por WhatsApp está disponível apenas no plano PROFISSIONAL',
                            textoBotao: 'Ok'
                        })
                    } else {
                        setAlerta({
                            show: true,
                            titulo: 'Opção Indisponível no Momento',
                            mensagem: 'O Envio de Propostas por WhatsApp estará disponível em breve no plano PROFISSIONAL',
                            textoBotao: 'Ok'
                        })
                    }
                }}
                clickLink={() => {
                    setModalMenu(false)
                    const link = `${window.location.host}/cliente/proposta/${base64_encode(propostaSelecionada.prop_id)}`
                    copy(link)
                    if (propostaSelecionada.prop_status !== 'aprovada') {
                        updateStatusProposta('enviada')
                    }
                    toast.success('Link Copiado!')
                    // setAlerta({
                    //     show: true,
                    //     titulo: 'Link de Acesso a Proposta',
                    //     mensagem: 'Link foi Copiado e Proposta foi Marcada como Enviada!',
                    //     textoBotao: 'Ok'
                    // })
                }}
            />
            <ModalInputSimples
                show={modalEmail}
                setShow={setModalEmail}
                onHide={() => setModalEmail(false)}
                centered
                titulo="Enviar Proposta por E-mail"
                descricao="Envie sua proposta por e-mail"
                botao="Enviar E-mail"
                valor={propostaSelecionada.cust_email}
                tipo="email"
                clickBotao={(email) => {
                    setModalEmail(false)
                    sendPropostaEmail(propostaSelecionada.prop_id, email)
                }}

            />
            <ToastContainer />
        </div>

    )
}

export default TelaPropostas